import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const ItemDescriptionTooltip = ({ description, show, position }) => {
  const [copied, setCopied] = useState(false);

  if (!description || !show) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(description);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  };

  // Use portal to render tooltip at document body level to avoid z-index issues
  return ReactDOM.createPortal(
    <div
      className="fixed pointer-events-auto transition-all duration-300"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -100%)',
        zIndex: 9999,
        opacity: show ? 1 : 0,
      }}
    >
      {/* Tooltip balloon */}
      <div className="bg-gray-900 text-white rounded-lg shadow-2xl px-4 py-3 min-w-[200px] max-w-[300px] relative">
        {/* Header with title and copy button */}
        <div className="flex items-center justify-between mb-1">
          <div className="text-xs font-semibold text-gray-300 uppercase tracking-wide">
            Item Description
          </div>
          <button
            onClick={handleCopy}
            className="ml-2 px-2 py-1 text-xs bg-gray-700 hover:bg-gray-600 rounded transition-colors flex items-center gap-1"
            title="Copy description"
          >
            {copied ? (
              <>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Copied!</span>
              </>
            ) : (
              <>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                <span>Copy</span>
              </>
            )}
          </button>
        </div>
        {/* Description */}
        <div className="text-sm leading-relaxed select-text cursor-text">
          {description}
        </div>
        {/* Arrow pointing down */}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2">
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-gray-900"></div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ItemDescriptionTooltip;

